import { render, staticRenderFns } from "./CreateVenue.vue?vue&type=template&id=b22a45ee&"
import script from "./CreateVenue.vue?vue&type=script&lang=js&"
export * from "./CreateVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports